import React, { useEffect } from 'react';

import Box from '@components/Atoms/Box';
import { useParams } from 'react-router-dom';
import TestSessionCard from '../TestSessionCard';
import NavTestletsList from './NavTestletsList';
import { useGetLearnosityExamTestSessions } from '../../hooks';
import mapTestSessions from '../../utils/mapTestSessions';

function NavTestSessionsList() {
  const { testSessionId } = useParams();
  const { data: testSessions } = useGetLearnosityExamTestSessions();

  const [selectedTestSessionId, setSelectedTestSessionId] = React.useState(
    testSessionId ? parseInt(testSessionId, 10) : null,
  );

  const testSessionData = mapTestSessions(testSessions);
  useEffect(() => {
    if (!selectedTestSessionId && testSessionId) {
      setSelectedTestSessionId(testSessionId);
    }
  }, [testSessionId]);
  if (!selectedTestSessionId || !testSessionId) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {testSessionData?.map((testSession) => (
        <React.Fragment key={testSession.id}>
          <TestSessionCard
            key={testSession.id}
            id={testSession.id}
            selectedTestSessionId={selectedTestSessionId}
            examName={testSession.examName}
            testSession={testSession}
            testSessionCardContent={
              <NavTestletsList
                testSessionId={testSession.id}
                setSelectedTestSessionId={setSelectedTestSessionId}
              />
            }
          />
        </React.Fragment>
      ))}
    </Box>
  );
}

export default NavTestSessionsList;
